import { forwardRef } from 'react'
import styled from 'styled-components'
import { colors } from '@/styles'

const Wrapper = styled.div<{ showFooterOverflow?: boolean }>`
  flex-shrink: 0;
  overflow: ${props => (props.showFooterOverflow ? 'visible' : 'hidden')};
  z-index: 1;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));

  position: relative;
  background-color: ${colors.grey96};
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-top: 1px solid ${colors.grey88};
  &[aria-hidden='true'] {
    display: none;
  }
`

const InnerWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0 16px;
  > div {
    width: 100%;
  }
`

const Outer: React.FC<{ isSheet?: boolean; children?: React.ReactNode }> = ({
  isSheet,
  children,
  ...rest
}) => (isSheet ? <>{children}</> : <Wrapper {...rest}>{children}</Wrapper>)

type ModalFooterProps = {
  children?: React.ReactNode
  isSheet?: boolean
  showFooterOverflow?: boolean
}

const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(
  ({ children, isSheet, ...rest }, ref) => {
    return (
      <Outer isSheet={isSheet} {...rest}>
        <InnerWrapper ref={ref}>{children}</InnerWrapper>
      </Outer>
    )
  }
)

export default ModalFooter
